(function (angular) {
    angular.module('app').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('app',
                {
                    abstract: true,
                    templateUrl: '/app/layout/main.html',
                    controller: "app.mainController",
                    controllerAs: "vMain",
                    resolve: {
                        supportedStates: ['$rootScope', 'supportService', '$q', function ($rootScope, supportService, $q) {
                            var deferred = $q.defer();
                            $rootScope.supportedStates = [];

                            supportService.getSellableStatesByPlan(siteContent.plan).then(function (response) {
                                var states = supportService.getStates();
                                var responseData = response.data;

                                if (responseData.includedStates && responseData.includedStates !== null && responseData.includedStates.length > 0) {
                                    $rootScope.supportedStates = states.filter(function (s) { return (responseData.includedStates.indexOf(s.abbr) >= 0); }).map(function (a) { return a.abbr; });
                                    deferred.resolve($rootScope.supportedStates);
                                }
                                else if (responseData.excludedStates && responseData.excludedStates !== null && responseData.excludedStates.length > 0) {
                                    $rootScope.supportedStates = states.filter(function (s) { return (responseData.excludedStates.indexOf(s.abbr) < 0); }).map(function (a) { return a.abbr; });
                                    deferred.resolve($rootScope.supportedStates);
                                }
                                else {
                                    $rootScope.supportedStates = [];
                                    deferred.resolve($rootScope.supportedStates);
                                }
                            });

                            return deferred.promise;
                        }]

                    }
                });

        if (environment.offline) {
            $urlRouterProvider.when('/', '/offline');
            $urlRouterProvider.when('', '/offline');
            $urlRouterProvider.otherwise('/offline');
        } else {
            $urlRouterProvider.when('/', '');
            $urlRouterProvider.otherwise('/not-found');
        }
    }]);
}(angular));